import { GetterTree } from 'vuex'
import { NotesState } from '@/store/modules/notes/types'
import { NoteModel } from '@/models/interfaces/note.model'

export const getters: GetterTree<NotesState, any> = {
  getNotes(state): NoteModel[] | null {
    return state.notes ? state.notes : null
  },
  getLoading(state): boolean {
    return state.loading
  }
}
